module.exports = __webpack_public_path__ + "assets/img/YP.fcd14ec0.png";